import { render, staticRenderFns } from "./wy-home-exp-pie-chart.vue?vue&type=template&id=e4fb38e0&"
import script from "./wy-home-exp-pie-chart.vue?vue&type=script&lang=js&"
export * from "./wy-home-exp-pie-chart.vue?vue&type=script&lang=js&"
import style0 from "./wy-home-exp-pie-chart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports